exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ../js/~/core-js/library/modules/_wks-ext.js
// module id = 230
// module chunks = 0